import { useState, useRef } from "react";
import { TextField, IconButton, Popper, Paper, ClickAwayListener, Box } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

// テキスト入力 or カレンダー選択を両立できるコンポーネント
type DateOrTextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
};
/**
 * 日付、文字列両方入力可能
 * @param param0 プロップス
 * @returns JSX.Element
 */
export default function DateOrTextField({ label, value, onChange }: DateOrTextFieldProps) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLElement | null>(null);

  const handleIconClick = () => {
    setOpen((prev) => !prev);
  };

  const handleDateSelect = (date: Dayjs | null) => {
    if (date) {
      onChange(date.format("YYYY/MM/DD")); // 選択した日付を文字列フォーマット
    }
    setOpen(false);
  };

  return (
    <Box position="relative">
      <TextField
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        // eslint-disable-next-line no-return-assign
        inputRef={(el) => (anchorRef.current = el)}
        // fullWidth
        InputProps={{
          endAdornment: (
            <IconButton onClick={handleIconClick} sx={{ p: 0, mr: -0.5 }}>
              <CalendarTodayIcon />
            </IconButton>
          ),
          inputProps: {maxLength: 100},
        }}
        sx={{ maxWidth: 207 }}
        size="small"
      />
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        sx={{ zIndex: 3000 }}
      >
        <Paper elevation={3}>
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <DateCalendar
              value={dayjs(value).isValid() ? dayjs(value) : null}
              onChange={handleDateSelect}
            />
          </ClickAwayListener>
        </Paper>
      </Popper>
    </Box>
  );
}
